const FaqRoutes = {
    createFaq: 'admin/faq',
    getFaqs: 'admin/faq',
    updateFaq: 'admin/faq',
    deleteFaq: 'admin/faq/',
};

export default FaqRoutes